import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { NgBusyModule } from 'ng-busy';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HotkeyModule } from 'angular2-hotkeys';
import { DataTableModule } from "angular-6-datatable";
import { CustomFormsModule } from 'ngx-custom-validators';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { GrdFilterPipe } from '../main/utility/grd-filter-pipe';
import { TableCustomFilterPipe } from '../main/utility/tableCustomFilter.pipe';
import { Uppercase } from "../main/validation/uppercase.directive";
import { OnlyNumber } from '../main/validation/onlynumber.directive';
import { InputTrimDirective } from '../main/validation/inputtrim.directive';
import { FilterPipe } from '../main/validation/filter.pipe';
import { NumericDirective } from '../main/validation/onlynumbernumeric.directive';
import { FinancialDate } from '../main/validation/financialdate.directive';
import { TwoDigitDecimaNumberDirective } from '../main/validation/twodecimalnumber.directive';
import { FourDigitDecimaNumberDirective } from '../main/validation/FourDigitDecimaNumberDirective.directive';
import { DatePipe } from '../main/validation/datefilter.pipe';
import { NgDatepickerModule } from 'ng2-datepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceComponent } from './invoice/invoice.component';
import { NumberToWordsPipe } from './numbers-to-words.pipe';
// import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartsModule } from 'ng2-charts';
import { ButtonRendererComponent } from '../main/masters/cellRendererCustomNotes.component';
import { CustomButtonRendererComponent } from '../main/masters/cellRenderCustomButton.component';
import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';
import { NgxLowerCaseDirectiveModule } from 'ngx-lower-case-directive';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { ProductTemplateComponent } from '../main/productTemplate.component'
import { UnitTemplateComponent } from '../main/UnitTemplate.component'
import { ProductTemplateGlobalComponent } from '../main/productTemplateGlobal.component'
import { vendorList } from '../main/vendorTemplate.component';
import { CustomerTemplateGlobalComponent } from '../main/customerTemplateGlobal.component';
import { CustomerTemplateComponent } from '../main/customerTemplate.component';
import { vendorTemplateGlobalComponent } from '../main/vendorTemplateGlobal.component';
import { MatMenuModule, MatListModule } from '@angular/material';
import { GeneralMenuComponent } from "../main/tools/generalMenu.component";
import { RouterModule } from '@angular/router';
import { AccountTemplateComponent } from '../main/accountTemplate.component';
import { ExportAsModule } from 'ngx-export-as';
import { HsnTemplateComponent } from '../main/hsnTemplate.component';
import { CommonReportComponent } from '../main/CommonReportTemplate.component';
import { commonLedgerTemplateComponent } from '../main/commonLedgerTemplate.component';
import { CommonVendorLedgerTemplateComponent } from '../main/CommonVendorLedgerTemplate.component';
import { CommonProductLedgerTemplateComponent } from '../main/CommonProductLedgerTemplate.component';
import { CommonVendorOutstandingTemplateComponent } from '../main/CommonVendorOutstandingTemplate.component';
import { CommonCustomerOutstandingTemplateComponent } from '../main/CommonCustomerOutstandingTemplate.component';
import { PayReceiptAdjustmentTemplateComponent } from '../main/PayReceiptAdjustmentTemplate.component';
import { AccountPostingTemplateComponent } from '../main/AccountPostingTemplate.component';
import { AccountTemplateJVComponent } from '../main/accountTemplatejv.component';
import { CommonCustomerDivisionRestrictTemplateComponent } from '../main/CommonCustomerDivisionRestrictTemplate.component';
import { ReportRequestTemplateComponent } from '../main/report-request-template.component';
import { EmailRequestTemplateComponent } from '../main/email-request-template.component';
import { CommonCostCentreEntry } from '../main/commonCostCentreEntry.component';
import { FooterTotalComponent } from '../main/footer-total.component';
import { LablePopupComponent } from '../main/lable-popup.component';

import { WarehouseDashboardComponent } from '../main/WarehouseDashboard.component';
import { OrderTrackerDashboardComponent } from '../main/OrderTrackerDashboard.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { PaymentVenOSTemplateComponent } from '../main/PaymentVenOSTemplate.component';
import {saleshistorycustomerwiseTemplateComponent} from '../main/saleshistorycustomerwiseTemplate.component'

//import * as XLSX from 'xlsx';
//const { read, write, utils } = XLSX;
@NgModule({
  imports: [
    CommonModule,
    [RouterModule],
    AgGridModule.withComponents([ButtonRendererComponent, CustomButtonRendererComponent]),
    BsDatepickerModule.forRoot(),
    // NgBusyModule,
    // NgDatepickerModule,
    HotkeyModule,
    MatProgressBarModule,
    FormsModule,
    // TooltipModule.forRoot(),
    NgSelectModule,
    // NgxChartsModule,
    ChartsModule,
    // DataTableModule,
    // CustomFormsModule,
    NgxUpperCaseDirectiveModule,
    NgxLowerCaseDirectiveModule,
    NgxTrimDirectiveModule,
    NgxCleaveDirectiveModule,
    MatMenuModule,
    MatListModule,
    MatTreeModule,
    MatIconModule,
    NgxEchartsModule,
  ],
  declarations: [
    GrdFilterPipe,
    TableCustomFilterPipe,
    GeneralMenuComponent,
    ProductTemplateComponent,
    UnitTemplateComponent,
    ProductTemplateGlobalComponent,
    CommonReportComponent,
    vendorList,
    CustomerTemplateGlobalComponent,
    CustomerTemplateComponent,
    vendorTemplateGlobalComponent,
    AccountTemplateComponent,
    OnlyNumber,
    Uppercase,
    InputTrimDirective,
    FilterPipe,
    NumericDirective,
    FinancialDate,
    TwoDigitDecimaNumberDirective,
    FourDigitDecimaNumberDirective,
    DatePipe,
    InvoiceComponent,
    ButtonRendererComponent,
    HsnTemplateComponent,
    CustomButtonRendererComponent,
    commonLedgerTemplateComponent,
    PayReceiptAdjustmentTemplateComponent,
    AccountPostingTemplateComponent,
    CommonVendorLedgerTemplateComponent,
    CommonVendorOutstandingTemplateComponent,
    CommonCustomerOutstandingTemplateComponent,
    AccountTemplateJVComponent,
    CommonProductLedgerTemplateComponent,
    CommonCustomerDivisionRestrictTemplateComponent,
    EmailRequestTemplateComponent,
    ReportRequestTemplateComponent,
    CommonCostCentreEntry,
    FooterTotalComponent,

    WarehouseDashboardComponent,
    OrderTrackerDashboardComponent,
    LablePopupComponent,
    PaymentVenOSTemplateComponent,
    saleshistorycustomerwiseTemplateComponent
  ],
  exports: [
    ProductTemplateComponent,
    UnitTemplateComponent,
    ProductTemplateGlobalComponent,
    CommonReportComponent,
    vendorList,
    GeneralMenuComponent,
    CustomerTemplateGlobalComponent,
    CustomerTemplateComponent,
    vendorTemplateGlobalComponent,
    AccountTemplateComponent,
    HsnTemplateComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GrdFilterPipe,
    TableCustomFilterPipe,
    AgGridModule,
    BsDatepickerModule,
    NgBusyModule,
    HotkeyModule,
    MatProgressBarModule,
    // TooltipModule,
    OnlyNumber,
    Uppercase,
    FilterPipe,
    NumericDirective,
    FinancialDate,
    TwoDigitDecimaNumberDirective,
    FourDigitDecimaNumberDirective,
    DatePipe,
    InputTrimDirective,
    NgDatepickerModule,
    NgbModule,
    NgSelectModule,
    DataTableModule,
    CustomFormsModule,
    InvoiceComponent,
    // NgxChartsModule,
    ChartsModule,
    NgxUpperCaseDirectiveModule,
    NgxLowerCaseDirectiveModule,
    NgxTrimDirectiveModule,
    NgxCleaveDirectiveModule,
    MatMenuModule,
    MatListModule,
    commonLedgerTemplateComponent,
    PayReceiptAdjustmentTemplateComponent,
    AccountPostingTemplateComponent,
    CommonVendorLedgerTemplateComponent,
    CommonVendorOutstandingTemplateComponent,
    CommonCustomerOutstandingTemplateComponent,
    AccountTemplateJVComponent,
    CommonProductLedgerTemplateComponent,
    CommonCustomerDivisionRestrictTemplateComponent,
    MatTreeModule,
    MatIconModule,
    EmailRequestTemplateComponent,
    ReportRequestTemplateComponent,
    CommonCostCentreEntry,
    FooterTotalComponent,

    WarehouseDashboardComponent,
    OrderTrackerDashboardComponent,
    LablePopupComponent,
    PaymentVenOSTemplateComponent,
    saleshistorycustomerwiseTemplateComponent
  ],
  providers: [
    DatePipe,

  ],
})
export class SharedModule {
  // static forChild(): ModuleWithProviders {
  //   return {
  //     ngModule: SharedModule,
  //     providers: [ InvoiceService ]
  //   };
  // }
}